const axios = require('axios');

const busApi = axios.create({
  // baseURL: 'https://noahface-employe-1596694177115.ts.r.appspot.com/api/v1/business/',
  baseURL: '/api/v1/business/',
});

const userApi = axios.create({
  // baseURL: 'https://noahface-employe-1596694177115.ts.r.appspot.com/api/v1/user/',
  baseURL: '/api/v1/user/',
});

module.exports = { busApi, userApi };
